<template>

  <div class="itin-flight" v-if="booking.BalanceDue > 0">
    <div class="itin-subheader">
      <div class="col-12">
        <div class="current-srch-container">
          <div class="row d-flex align-items-center text-left">
            <div class="col-12 col-sm-9 text-center text-sm-left px-0">
              <h4>
                <font-awesome-icon icon="credit-card"/>
                Saldo Pendiente: ARS {{toCurrencyFormat(booking.BalanceDue)}}
              </h4>
            </div>
            <div class="col-12 col-sm-3 text-right px-0">
              <button class="btn btn-andes w-100" @click="goToPayment">{{ $t('Pagar') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--      <div class="itin-subheader">-->
    <!--        <h4 class="pull-left"><font-awesome-icon icon="credit-card"/> Saldo Pendiente: ARS {{toCurrencyFormat(booking.BalanceDue)}}</h4>-->
    <!--        <a class="card-btn" @click="goToPayment" >{{ $t('Pagar') }}</a>-->
    <!--      </div>-->
  </div>

</template>

<script>
  import {mapState} from 'vuex';
  import moment from 'moment';
  import {formatMoney} from "../../utils/utils";
  import { makePaymentV2 } from '@/api/api';

  export default {
    name: 'payment-pending',
    computed: {
      ...mapState(['booking']),
    },
    methods: {
      toCurrencyFormat: function (amount) {
        return formatMoney(amount);
      },
      goToPayment: async function () {
        /*gtag('event', 'pay_pending_click', {
          'event_category': "payment"
        });
        this.$router.replace('/payment-pending');
        */
       const booking = this.booking;
       const passenger_info = booking.Passengers[0];
       const segment_info = passenger_info.Segments[0]?.Legs[0]?.InventoryLeg;
       const departureStation = segment_info.DepartureStation;
       const arrivalStation = segment_info.ArrivalStation;
       const sta = segment_info.STA;
       const std = segment_info.STD;

       const staUTC = moment(sta).utc().format();
       const stdUTC = moment(std).utc().format();
      
       
       this.$store.commit('loading', true);

       await makePaymentV2(booking, departureStation, arrivalStation, staUTC, stdUTC, (response) => {
          if (response && response.URL) {
            window.location.href = response.URL;
          } else {
            this.$store.commit('loading', false);
            this.$store.commit('error', 'Error al procesar el pago. Por favor,  intente nuevamente.');    
          }
       });
      }
    }
  }
</script>

